import * as React from 'react';
import { useState, useEffect } from 'react';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';

interface props {
  methodToExecuteOnConfirmation: Function;
  openDialog: boolean;
  closeDialog: () => void;
  customMessage?: string;
}

export default function ConfirmationDialogue ({ methodToExecuteOnConfirmation, openDialog, closeDialog, customMessage }: props) {
  const [disableDelete, setDisableDelete] = useState<boolean>(false);


  useEffect(() => {
    if(openDialog)
      setDisableDelete(false);
  }, [openDialog]);
  return (
    <Dialog
    open={openDialog}
    onClose={closeDialog}
    PaperProps={{
      style: {
        width: '500px',
        maxWidth: '500px',
      },
    }}
    >
      <DialogContent>
        <Stack direction="column" alignItems="center" sx={{ my: 4, mx: 2 }}>
          <Typography variant="h3" sx={{ mb: 3 }}>
            Are you sure?
          </Typography>
          <Typography sx={{ mb: 1 }}>
            {customMessage || "Do you really want to delete this? This process cannot be undone."}
          </Typography>
          <Stack direction="row" sx={{ mt: 4 }}>
            <Button
              variant="outlined"
              onClick={closeDialog}
              sx={{ width: '100px', mr: 3 }}
            >
              Cancel
            </Button>
            <Button
              disabled={disableDelete}
              variant="outlined"
              onClick={() => {
                setDisableDelete(true);
                methodToExecuteOnConfirmation();
              }}
              color="error"
              sx={{ width: '100px' }}
            >
              Yes
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
